import { Placement } from '@floating-ui/dom';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { cn } from '@theprintbar/shared';
import React, { useState } from 'react';

interface InfoPopupProps {
	title: string;
	buttonText?: string;
	children: React.ReactNode;
	className?: string;
	iconClassName?: string;
}

export function InfoPopup({ title, buttonText, children, iconClassName, className }: InfoPopupProps) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<button
				onClick={() => setOpen(true)}
				className={cn('font-bold inline-flex items-center text-xs underline', !!buttonText && 'text-grey', className)}
			>
				<span className="sr-only">{open ? 'Open' : 'Close'} information popover</span>
				{buttonText && <span className="mr-1">{buttonText}</span>}
				<InformationCircleIcon className={cn('h-5 w-5', iconClassName)} />
			</button>
			<Dialog open={open} onClose={() => setOpen(false)} className="relative z-50">
				<DialogBackdrop className="fixed inset-0 bg-black/30" />
				<div className="fixed inset-0 flex w-screen items-center justify-center p-4">
					{/* The actual dialog panel  */}
					<DialogPanel className="w-screen m-4 lg:max-w-lg space-y-4 rounded-3xl shadow-lg p-8 text-white bg-blue">
						<div className="flex items-center justify-between">
							<DialogTitle className="text-lg">{title}</DialogTitle>
							<button onClick={() => setOpen(false)}>
								<XMarkIcon className="h-5 w-5 flex-none fill-slate-400 group-hover:fill-slate-500 dark:fill-slate-500 md:group-hover:fill-slate-400" />
							</button>
						</div>
						{children}
					</DialogPanel>
				</div>
			</Dialog>
		</>
	);
}
